const validator = require('ui-validator');

const isSigned = validator.createValidator((options, value) => {
  if (value !== 'on') {
    return 'Check the box to continue';
  }

  return undefined;
});

const v = validator.validators;
const validations = {
  agreements: {
    required: v.required({ message: 'Check the box to continue' }),
    isSigned: isSigned(),
  },
};

export default validations;

